/* Выбор голоса строки «Голос ›»: общий список голосов (BotCore.voiceHost.page, APP-SPEC-1-tts.md §3.13) с отбором «только с переозвучкой»;
   сведения о голосе подтверждает сервер (GET голоса), голос без is_s2s не встаёт. Логика — как у features/tts/VoicePick.tsx,
   но строка рисуется разметкой прототипа (.voicepill с подписью и красной пометкой). */
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { endpoints } from '../../api';
import type { Voice } from '../../api/types';

export function useVoicePicker({ value, disabled, onPick }: { value: Voice | null; disabled: boolean; onPick(voice: Voice): void }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const request = useRef<AbortController | null>(null);
  const off = useRef(disabled);
  const pick = useRef(onPick);
  useLayoutEffect(() => {
    off.current = disabled;
    pick.current = onPick;
    if (disabled) request.current?.abort();
  });
  useEffect(() => () => request.current?.abort(), []);
  function open() {
    const host = (window as unknown as { BotCore?: { voiceHost?: { page(cb: (id: number) => void, current: number | null, o: { only: string }): void } } })
      .BotCore?.voiceHost;
    if (off.current || !host) return;
    setError('');
    host.page(
      id => {
        if (off.current) return;
        request.current?.abort();
        const current = new AbortController();
        request.current = current;
        setBusy(true);
        void endpoints
          .voiceDetails(id, current.signal)
          .then(voice => {
            if (current.signal.aborted || request.current !== current || off.current) return;
            if (voice.id !== id) throw new Error('voice_mismatch');
            if (!voice.is_s2s) throw new Error('voice_not_s2s');
            pick.current(voice);
          })
          .catch(failure => {
            if (!current.signal.aborted && request.current === current)
              setError(
                failure instanceof Error && failure.message === 'voice_not_s2s'
                  ? 'Этот голос не умеет переозвучку записи. Выберите другой.'
                  : 'Не удалось выбрать голос. Попробуйте ещё раз.',
              );
          })
          .finally(() => {
            if (request.current === current) setBusy(false);
          });
      },
      value?.id ?? null,
      { only: 's2s' },
    );
  }
  return { open, busy, error };
}
